import { IMG_NO_RESULTS_PRODUCT_COMPARISON } from "~/utils/url/staticResources";
import { Button, Box, Stack, Typography, styled } from "@schaeffler-commerce/design-system";
import { useTranslation } from "react-i18next";

const Container = styled(Stack)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
});

const EmptyComparison = ({ openQuickEntry }: { openQuickEntry: () => void }) => {
  const { t } = useTranslation();

  return (
    <Container>
      <Typography variant="headlineLarge" sx={{ mb: 2.5, textAlign: "center" }}>
        {t("emptyComparison.title")}
      </Typography>
      <Box component="img" src={IMG_NO_RESULTS_PRODUCT_COMPARISON} alt="" sx={{ mb: 4 }} />
      <Box sx={{ mb: 1.25 }}>
        <Button onClick={openQuickEntry}>{t("emptyComparison.addProducts")}</Button>
      </Box>
    </Container>
  );
};

export default EmptyComparison;
